import { Telemetry, ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

export const VIZPORTAL_SOURCE = 'VIZPORTAL';

// List of events. The event name will be what appears in the database.
export enum ConductorAwarenessEvents {
  maestroConductorAwarenessNonDm = 'maestro_conductor_awareness_non_dm'
}

export enum ConductorAwarenessActionTypes {
  showConductorAwareness = 'SHOW_CONDUCTOR_AWARENESS',
  hideConductorAwareness = 'HIDE_CONDUCTOR_AWARENESS',
  sawConductorAwareness = 'SAW_CONDUCTOR_AWARENESS',
  learnMoreConductorAwareness = 'LEARN_MORE_CONDUCTOR_AWARENESS',
}

export interface ConductorAwarenessEvent extends ValidTelemetryEvent {
  type: ConductorAwarenessEvents;
  action_type: string;
  product_source: string;
}

export function sendSawConductorAwarenessTelemetry() {
  Telemetry.sendEvent<ConductorAwarenessEvent>({
    type: ConductorAwarenessEvents.maestroConductorAwarenessNonDm,
    action_type: ConductorAwarenessActionTypes.sawConductorAwareness,
    product_source: VIZPORTAL_SOURCE
  });
}

export function sendShowConductorAwarenessTelemetry() {
  Telemetry.sendEvent<ConductorAwarenessEvent>({
    type: ConductorAwarenessEvents.maestroConductorAwarenessNonDm,
    action_type: ConductorAwarenessActionTypes.showConductorAwareness,
    product_source: VIZPORTAL_SOURCE
  });
}

export function sendHideConductorAwarenessTelemetry() {
  Telemetry.sendEvent<ConductorAwarenessEvent>({
    type: ConductorAwarenessEvents.maestroConductorAwarenessNonDm,
    action_type: ConductorAwarenessActionTypes.hideConductorAwareness,
    product_source: VIZPORTAL_SOURCE
  });
}

export function sendLearnMoreConductorAwarenessTelemetry() {
  Telemetry.sendEvent<ConductorAwarenessEvent>({
    type: ConductorAwarenessEvents.maestroConductorAwarenessNonDm,
    action_type: ConductorAwarenessActionTypes.learnMoreConductorAwareness,
    product_source: VIZPORTAL_SOURCE
  });
}

